/**
 * Card number input used for adding a card
 *
 * Dependent on getCardSpecs() from https://github.paypal.com/ConsumerWeb-Modules/consumerweb-card/blob/master/lib/card-config.js,
 * but you could just supply an object of specifications similar to what getCardSpecs returns.
 */

import React from 'react';
import PropTypes from 'prop-types'
import { StyleSheet, css } from 'aphrodite';
import classNames from 'classnames';

const STYLES = StyleSheet.create({
	logoWrapper: {
		height: '100%',
		position: 'absolute',
		top: 0,
		right: 0
	},

	dropdown: {
		height: 42,
		padding: 0,
		textIndent: 10,
		WebkitAppearance: 'none',
		MozAppearance: 'none',
		appearance: 'none',
		'@-moz-document url-prefix()': {
			textIndent: 2.5
		},
		'::-ms-expand': { display: 'none' },
	},

	arrow: {
		position: 'absolute',
		right: 10,
		top: 20,
		cursor: 'default',
		pointerEvents: 'none'
	},

	logo: {
		display: 'inline-block',
		marginTop: 12,
		marginRight: 2
	},

	errorMessage: {
		WebkitTransition: 'all 0.25s ease-in-out',
		MozTransition: 'all 0.25s ease-in-out',
		msTransition: 'all 0.25s ease-in-out',
		OTransition: 'all 0.25s ease-in-out',
		transition: 'all 0.25s ease-in-out'
	}
});

class PhoneType extends React.Component {
	constructor(props) {
		super();
		const { defaultNumber: { type = 'Mobile' } = {} } = props
		this.state = {
			type: type,
			phoneTypeErrorMessage: '',
			showIsRequiredError: false
		};
	}

	handleChange = (event) => {
		let value = event.target.value;
		this.setState({ type: value });
		this.props.changePhoneType(value);
		return value
	}

	render() {

		const { errorMessage } = this.props
		const { phoneType: label, phoneTypeMobile: labelMobile, phoneTypeHome: labelHome, phoneTypeWork: labelWork } = this.props.guestLabels

		let { phoneTypeErrorMessage } = this.state;
		let errorMessageClassNames = classNames(css(STYLES.errorMessage), {
			'vx_form-control-message': errorMessage || phoneTypeErrorMessage
		});
		let errorStyles = {
			height: 0,
			padding: 0
		};
		if (errorMessage || phoneTypeErrorMessage) {
			errorStyles = { height: '100%' };
		}


		return (
			<div className={classNames({
				'vx_has-error-with-message': errorMessage,
				'vx_has-error': errorMessage,
			})} style={{ margin: '0 0 10px 0', position: 'relative' }}>
				<div style={{ position: 'relative' }}>
					<select id="phoneTypeSelection"
						className={`vx_form-control vx_form-control_complex ${css(STYLES.dropdown)}`}
						value={this.state.type}
						onChange={this.handleChange}>
							<option value="" disabled>{label}</option>
							<option value="Mobile">{labelMobile}</option>
							<option value="Home">{labelHome}</option>
							<option value="Work">{labelWork}</option>
					</select>
					<label htmlFor="phoneTypeSelection" className={`icon icon-arrow-down-small ${css(STYLES.arrow)}`}></label>
					<div className={errorMessageClassNames} style={errorStyles}>{errorMessage || phoneTypeErrorMessage}</div>
				</div>
			</div>
		)
	}
}

PhoneType.propTypes = {
	changePhoneType: PropTypes.func.isRequired,
	errorMessage: PropTypes.string,
	guestLabels: PropTypes.object
};

export default PhoneType;



// WEBPACK FOOTER //
// ./components/phone-type.js